import Button from "components/Button";
import { FileSelector } from "components/FileSelector";
import Input from "components/Input";
import Spinner from "components/Spinner";
import Text from "components/Text";
import useFileUploader from "hooks/useFileUploader";
import { BsTrash } from "react-icons/bs";

const BasicView = ({ disabled, value, onChange }) => {
  const photosUploader = useFileUploader((urls) => {
    onChange({ photos: [...value.photos, ...urls] });
  });

  return (
    <div className="card">
      <h4>Basic Info 基本信息</h4>
      <div className="mt-2 -mx-2">
        <table>
          <tbody>
            <tr>
              <td>
                <label>Company Name(中文):</label>
              </td>
              <td>
                <div className="flex items-center space-x-1">
                  <Input
                    disabled={disabled}
                    value={value.companyNameCn}
                    onChange={(e) =>
                      onChange({ companyNameCn: e.target.value })
                    }
                  />
                  <span className="pl-1 font-bold text-red-600">*</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <label>Contact 联系人(职位):</label>
              </td>
              <td>
                <div className="flex items-center space-x-1">
                  <Input
                    disabled={disabled}
                    value={value.contactPerson}
                    onChange={(e) =>
                      onChange({ contactPerson: e.target.value })
                    }
                  />
                  <span className="pl-1 font-bold text-red-600">*</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <label>Phone 电话:</label>
              </td>
              <td>
                <div className="flex items-center space-x-1">
                  <Input
                    disabled={disabled}
                    type="tel"
                    value={value.phone}
                    onChange={(e) => onChange({ phone: e.target.value })}
                  />
                  <span className="pl-1 font-bold text-red-600">*</span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <label>Address 联系地址(中文):</label>
              </td>
              <td>
                <div className="flex items-center space-x-1">
                  <Text
                    disabled={disabled}
                    value={value.address}
                    onChange={(e) => onChange({ address: e.target.value })}
                  />
                  <span className="pl-1 font-bold text-red-600">*</span>
                </div>
              </td>
            </tr>

            <tr className="">
              <td className="pt-6">
                <label className="text-base opacity-100">
                  Introduction 公司介绍
                </label>
              </td>
            </tr>

            <tr>
              <td>
                <label>Numbers of Employees 公司规模(人数):</label>
              </td>
              <td className="w-full">
                <Input
                  disabled={disabled}
                  type="number"
                  value={value.numberOfEmployees}
                  onChange={(e) =>
                    onChange({ numberOfEmployees: e.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Year of Established 成立成份:</label>
              </td>
              <td>
                <Input
                  disabled={disabled}
                  type="number"
                  value={value.yearOfEstablished}
                  onChange={(e) =>
                    onChange({ yearOfEstablished: e.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Major Products 主要产品:</label>
              </td>
              <td>
                <Input
                  disabled={disabled}
                  value={value.majorProducts}
                  onChange={(e) => onChange({ majorProducts: e.target.value })}
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Equipment and Facilities 设备介绍:</label>
              </td>
              <td>
                <Input
                  disabled={disabled}
                  value={value.equipmentAndFacilities}
                  onChange={(e) =>
                    onChange({ equipmentAndFacilities: e.target.value })
                  }
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Major Market 主要市场:</label>
              </td>
              <td>
                <Input
                  disabled={disabled}
                  value={value.majorMarket}
                  onChange={(e) => onChange({ majorMarket: e.target.value })}
                />
              </td>
            </tr>
            <tr>
              <td>
                <label>Photos 公司介绍图片:</label>
              </td>
              <td>
                <div>
                  {value.photos.map((url, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between space-x-2 border-b"
                    >
                      <a href={url} target="_blank" rel="noreferrer">
                        <img src={url} className="h-16 py-2" alt="Company" />
                      </a>
                      <Button
                        danger
                        onClick={() => {
                          onChange({
                            photos: value.photos.filter((_, i) => i !== index),
                          });
                        }}
                      >
                        <BsTrash />
                      </Button>
                    </div>
                  ))}
                </div>
                {photosUploader.isUploading ? (
                  <div className="flex">
                    <div>
                      <Spinner size={18} />
                    </div>
                  </div>
                ) : (
                  <FileSelector
                    disabled={disabled}
                    className="mt-2"
                    title="Upload Photos 上传图片"
                    accept="image/*"
                    onChange={(e) => {
                      const files = [...e.target.files];
                      photosUploader.startUpload(files);
                      e.target.value = null;
                    }}
                  />
                )}

                <div className="opacity-70 text-xs">
                  提交公司图片以助于我们更全面的了解。
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BasicView;
